import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { useStyles } from './styles';
import { AppDepartmentTable } from 'components/Tables/DepartmentUserTable/departmentApp';
const DepartmentAppTable: FC = observer(() => {
  const classes = useStyles();
  return (
    <Container maxWidth='xl' className={classes.container}>
      <AppDepartmentTable />
    </Container>
  );
});

export default DepartmentAppTable;
